module.exports = __webpack_public_path__ + "c4f508e7c4f01a9eeba7f08155cde04e.woff";